import React, {Fragment} from "react";
import {withRouter} from "react-router-dom";
import AgentCommissionSummaryComponent from "../../components/AgentCommissionSummaryComponent";

class CommissionSummaryIndex extends React.Component {

    constructor(props) {
        super(props);

        this.props.changeHeader("Commission");

    }

    render() {
        return <Fragment>
            <br />
            <AgentCommissionSummaryComponent />
        </Fragment>
    }

}

export default withRouter(CommissionSummaryIndex)